// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationENUS from './en-US.json';
import translationENUK from './en-UK.json';
import translationJA from './ja.json';
import { UATConstants, updateUATConstants } from 'src/Common/Models/UATConstants';

const resources = {
  enUS: { translation: translationENUS },
  enUK: { translation: translationENUK },
  ja: { translation: translationJA },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng:"en-US", // default language
    keySeparator: false, // Disable key separator for nested keys
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });
export const applyI18n = (constants: UATConstants, language: string): UATConstants => {
  // Clone the constants object to avoid mutating the original object
  const updatedConstants: UATConstants = { ...constants };
  updateUATConstants(language);
  // Replace constant values with translations
  // Object.keys(updatedConstants).forEach((constantName) => {
  //     // Assign the translated value to the constant
  //     UATConstants.PlaceholdersAndTitles[constantName] = translations[constantName];
  // });

  return updatedConstants;
};


export default i18n;
